import { useQuery } from "@tanstack/react-query";
import { getHighscores, Highscore } from "../api/api";
import { Trophy, RefreshCw } from "lucide-react";

export function HighscoresBox() {
  const {
    data: scores,
    isLoading,
    isError,
    refetch,
  } = useQuery<Highscore[]>({
    queryKey: ["highscores"],
    queryFn: getHighscores,
    staleTime: 60 * 15000,
    gcTime: 60 * 60 * 1000,
    refetchOnWindowFocus: false,
  });

  return (
    <div className="highscores-box">
      <h2>
        <Trophy size={28} /> Najlepsze wyniki
      </h2>

      {isLoading && (
        <div className="loader-wrapper" style={{ padding: "30px 0" }}>
          <div className="loader-bar" />
          <div className="loader-sub">Ładowanie listy kapitanów…</div>
        </div>
      )}

      {isError && (
        <div className="result-message" style={{ color: "var(--red)" }}>
          Nie udało się pobrać wyników z serwera.
          <button
            className="btn-ghost"
            onClick={() => refetch()}
            style={{ marginLeft: 12, padding: "6px 14px", fontSize: "0.75rem" }}
          >
            <RefreshCw size={14} /> Spróbuj ponownie
          </button>
        </div>
      )}

      <ol>
        {scores &&
          scores.map((s, i) => (
            <li key={i}>
              <div className="hs-meta">
                <span className="hs-name">{s.name}</span>
                <span className="hs-sub">
                  {s.n && <>N: {s.n}</>}
                  {s.date && (
                    <span className="highscore-date">
                      {" "}· {new Date(s.date).toLocaleString()}
                    </span>
                  )}
                </span>
              </div>
              <span className="hs-level">Lvl {s.level}</span>
            </li>
          ))}
        {scores && scores.length === 0 && !isLoading && !isError && (
          <li>
            <div className="hs-meta">
              <span className="hs-name">Brak wyników</span>
              <span className="hs-sub">Bądź pierwszym kapitanem!</span>
            </div>
          </li>
        )}
      </ol>
    </div>
  );
}
